module.exports = __webpack_public_path__ + "img/icon-sun.9330bc7c.svg";